import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClaimByProjectComponent } from './claim-by-project.component';

const routes: Routes = [
  { path: '', component: ClaimByProjectComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ClaimByProjectRoutingModule { }